import * as actionTypes from '../actions/actionTypes';
import {updateObject} from "../../shared/utility";

const initialState = {
    colors: [],
    trims: [],
    loading: false,
    error: null,
    showFields: []
}


const setData = (state, action) => {
    const updatedState = JSON.parse(JSON.stringify(action.data));
    return updateObject(state, updatedState);
}

const resetData = (state, action) => {
    return initialState
}


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_BLACKBOOK:
            return setData(state, action);
        case actionTypes.RESET_BLACKBOOK:
            return resetData();
        default:
            return state;
    }
};

export default reducer;